
/*
 Author: Vinod
 Date: 08/04/2020
 Issue Description: Even after deselecting weekly offs, they are going in request.
 search_string: PL_3046
*/

<template>
  <div class="business">
    <div class="top-bar">
      <span @click="goBackToPaygroup">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">Pay Computation</span>
    </div>
    <div>      
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="payroll-computation alignClass">
        <!-- <hr> -->
        <div class="row">
          <div class="col-6">
            <div class="payroll-label deductions-text">Pay Days in a Month*</div>
            <div v-for="(paydayType,index) in payDaysmonthList" :key="index">
              <tl-radio
                class="margintop-10"
                name="gender"
                :label="paydayType.name"
                :id="paydayType.name"
                :value="paydayType.id"
                @change="currentPayType(paydayType)"
                v-model="payDays"
              />
            </div>
            <div v-if="isBaseDays">
              <txt
                class="margintop-20"
                label="Enter basedays"
                name="BaseDays"
                v-model="payDaysValue.baseDays"
                v-validate="'required|numeric|min_value:0|max_value:31'"
                :classname="errors.has('BaseDays')"
                :errormsg="errors.first('BaseDays')"
              />
            </div>
            <br />
            <div v-if="isExcludeWeeklyOff">
              <tl-checkbox
                label="Exclude Weekly Off"
                @change="(val)=>{exclude=val}"
                v-model="exclude"
              ></tl-checkbox>
              <div v-if="this.exclude">
                <div class="margintop-10">
                  <ul class="flex-box">
                    <span class="excludelabel">Select Weekly Offs:</span>
                    <li
                      :class="{'selected': day.selected}"
                      v-for="(day,index) in weekDays"
                      :key="index"
                      :value="day.day"
                      @click="weekOffDays(index)"
                    >{{day.day}}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="grey-line" />
            <div class="padding-t-l">
              <tl-checkbox
                label="Deductions should be negative in arrears"
                name="deduction"
                v-model="deduction"
              ></tl-checkbox>
            </div>
          </div>
        </div>
      <bottom-action-container class="bottomClass">
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="goBackToPaygroup" />
            <btn text="Save" type="primary" @click="save" />
          </btn-grp>
        </template>
      </bottom-action-container>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { SalaryComponentsConstants } from "../../../../../../apis/constants.js";
export default {
  name: "PayrollComputation",
  props: {
    payComputationData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
      payCycleId: "onboard/settings/payroll_cycle/payCycleId"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    }
  },
  mounted() {
    if (Object.keys(this.payComputationData).length) {
      this.setPayComputaionData();
    } else {
      this.fetchData();
    }
  },
  activated() {
    this.fetchData();
  },
  data() {
    return {
      payDaysmonthList: SalaryComponentsConstants.payDaysmonthList,
      weekDays: [
        {
          day: "Mon",
          selected: false
        },
        {
          day: "Tue",
          selected: false
        },
        {
          day: "Wed",
          selected: false
        },
        {
          day: "Thu",
          selected: false
        },
        {
          day: "Fri",
          selected: false
        },
        {
          day: "Sat",
          selected: false
        },
        {
          day: "Sun",
          selected: false
        }
      ],
      toast: false,
      selected: false,
      errmsg: "",
      isBaseDays: false,
      isExcludeWeeklyOff: false,
      baseDays: "",
      payDays: "",
      deduction: false,
      payDaysValue: {
        baseDays: null,
        weeklyOff: []
      },
      exclude: false,
      selectedWeekOffDays: [],
      selectedOption: ""
    };
  },
  methods: {
    ...mapActions({
      act_fetchData: "onboard/settings/payroll_computation/fetchAll",
      act_create: "onboard/settings/payroll_computation/create"
    }),

    /* function to go back to add pay group */
    goBackToPaygroup() {
      this.$emit("paycomputation");
    },

    /* function to set as selected day after clicking on week days */
    weekOffDays(idx) {
      try {
        this.weekDays[idx].selected = !this.weekDays[idx].selected;
        if (this.weekDays[idx].selected) {
          if (
            !this.selectedWeekOffDays.includes(
              item => item == this.weekDays[idx].day
            )
          ) {
            this.selectedWeekOffDays.push(this.weekDays[idx].day);
          }
        } else {
          this.selectedWeekOffDays.splice(
            this.selectedWeekOffDays.findIndex(
              item => item == this.weekDays[idx].day
            ),
            1
          );
        }
        this.payDaysValue.weeklyOff = [...new Set(this.selectedWeekOffDays)];
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to set pay computation data */
    setPayComputaionData() {
      try {
        let payrollObject = this.payComputationData;
        this.payDays = payrollObject.payDaysInMonthId;
        this.selectedWeekOffDays = payrollObject.pay_days_value.weeklyOff
          ? payrollObject.pay_days_value.weeklyOff
          : [];
        this.isExcludeWeeklyOff = this.selectedWeekOffDays
          ? this.selectedWeekOffDays.length
            ? true
            : false
          : false;
        this.exclude = this.isExcludeWeeklyOff ? true : false;
        if (this.selectedWeekOffDays) {
          for (let week of this.weekDays) {
            for (let item of this.selectedWeekOffDays) {
              if (item == week.day) {
                week.selected = true;
              }
            }
          }
        }
        this.payDaysValue.weeklyOff = this.selectedWeekOffDays;
        for (let index = 0; index < this.payDaysmonthList.length; index++) {
          if (this.payDaysmonthList[index].id === payrollObject.pay_day_type) {
            this.currentPayType(this.payDaysmonthList[index]);
            break;
          }
        }
        this.payDaysValue.baseDays = payrollObject.pay_days_value.baseDays
          ? payrollObject.pay_days_value.baseDays
          : "";
        this.deduction = payrollObject.deduction_negative_arrear;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* server calll to get pay computation data fro current Legal Entity */
    async fetchData() {
      try {
        let res = await this.act_fetchData(this.leId);
        let payComputationData = res.data.payload.data;
        if (payComputationData) {
          let payrollObject = payComputationData;
          this.payDays = payrollObject.payDaysInMonthId;
          this.selectedWeekOffDays = payrollObject.pay_days_value.weeklyOff
            ? payrollObject.pay_days_value.weeklyOff
            : [];
          this.isExcludeWeeklyOff = this.selectedWeekOffDays
            ? this.selectedWeekOffDays.length
              ? true
              : false
            : false;
          this.exclude = this.isExcludeWeeklyOff ? true : false;
          if (this.selectedWeekOffDays) {
            for (let week of this.weekDays) {
              for (let item of this.selectedWeekOffDays) {
                if (item == week.day) {
                  week.selected = true;
                }
              }
            }
          }
          this.payDaysValue.weeklyOff = this.selectedWeekOffDays;
          for (let index = 0; index < this.payDaysmonthList.length; index++) {
            if (
              this.payDaysmonthList[index].id === payrollObject.pay_day_type
            ) {
              this.currentPayType(this.payDaysmonthList[index]);
              break;
            }
          }
          this.payDaysValue.baseDays = payrollObject.pay_days_value.baseDays
            ? payrollObject.pay_days_value.baseDays
            : "";
          this.deduction = payrollObject.deduction_negative_arrear;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to save pay computation data for the pay group */
    async performAction() {
      try {
        // PL_3046
        if (
          this.selectedOption == "Current month calendar days" ||
          this.selectedOption == "Previous month calendar days"
        ) {
          if (!this.exclude) {
            this.payDaysValue.weeklyOff = [];
          }
          this.payDaysValue.baseDays = null;
        } else {
          this.payDaysValue.weeklyOff = [];
        }
        this.apirequestObj = {
          id: this.payCycleId,
          pay_day_type: this.payDays,
          le_id: this.leId,
          deduction_negative_arrear: this.deduction,
          pay_days_value: this.payDaysValue
        };
        this.$emit("updatePaycomputation", this.apirequestObj);
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to validate the form */
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        }
      });
    },

    /* function to show field based on radio selection */
    currentPayType(event) {
      try {
        switch (event.name) {
          case "Current month calendar days":
            this.payDays = event.id;
            this.selectedOption = event.name;   // PL_3046
            this.isBaseDays = false;
            this.isExcludeWeeklyOff = true;
            break;
          case "Previous month calendar days":
            this.payDays = event.id;
            this.isBaseDays = false;
            this.selectedOption = event.name;  // PL_3046
            this.isExcludeWeeklyOff = true;
            break;
          case "Fixed base days":
            this.payDays = event.id;
            this.isBaseDays = true;
            this.selectedOption = event.name;   // PL_3046
            this.isExcludeWeeklyOff = false;
            break;
          default:
            break;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.business {
  width: 100%;
  height: 100%;
  margin-bottom: 200px;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}

.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}
.content-description {
  margin-top: 20px;
  width: 33%;
}
.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.payroll-computation {
  margin-bottom: 150px;
  width: 100%;
  .payroll-label {
    font-size: 14px;
    font-weight: 600;
    color: #646464;
  }
  hr {
    height: 2px;
    color: #34c0be;
    background-color: #34c0be;
    border: none;
    opacity: 0.3;
  }
}
.alignClass {
  margin-top: 35px;
  margin-left: 35px;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.bottomClass {
  margin-top: -80px;
}

ul {
  padding-left: 0px;
  margin-left: 24px;
}

.flex-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 4px;
  background: #f9f9f9;
  li {
    list-style: none;
    font-weight: 500;
    padding: 15px 10px;
    cursor: pointer;
    &:hover {
      background-color: #34c0be52;
    }
    &.selected {
      background-color: #34c0be;
    }
  }
}
.excludelabel {
  align-self: center;
  padding-left: 10px;
}

.deductions-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}

.grey-line {
  width: 1126px;
  height: 2px;
  margin-top: 24px;
  transform: rotate(0deg);
  border: solid 1px #d8d8d8;
}
</style>
